<div class="w-full relative h-full" [ngClass]="{'custom-visual-data': !isCanvas, 'flex justify-center items-center': reportVisualType === 'CHART' && !isCanvas}">
  <div *ngIf="reportVisualDataLoading; else dataContent" class="loading-state">
    <div class="flex items-center justify-center">
      <app-loader [loadingText]="'Loading...'" />
    </div>
  </div>
  <ng-template #dataContent>
    @if(reportVisualData.length > 0){
    <div *ngIf="rowData.length > 0" style="position: absolute; left: -10000px; top: -10000px; width: 1px; height: 1px; overflow: hidden;">
      <ag-grid-angular
        style="width: 1px; height: 1px;"
        class="ag-theme-quartz"
        [columnDefs]="columnDefs"
        [rowData]="rowData"
        [defaultColDef]="defaultColDef"
        [gridOptions]="hiddenGridOptions"
        (gridReady)="onHiddenGridReady($event)">
      </ag-grid-angular>
    </div>
    <div *ngIf="reportVisualType == 'TABLE'; else showChartVisual" class="h-full mx-0" [ngClass]="{'mx-8': !isCanvas}">
      <div class="flex justify-center w-full items-center" [ngClass]="{'h-full': isCanvas}">
        <ag-grid-angular
        [ngStyle]="{'width': '100%', 'height': isCanvas ? '100%' : '620px'}"
        class="ag-theme-quartz"
        [columnDefs]="columnDefs"
        [rowData]="rowData"
        [defaultColDef]="defaultColDef"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        (filterChanged)="onFilterChanged()"
        (sortChanged)="onSortChanged()">
      </ag-grid-angular>
      </div>
    </div>
    <ng-template #showChartVisual>
      <div [ngStyle]="{'width': '100%', 'height': isCanvas ? '100%' : '620px', 'position': 'relative'}">
        <app-ag-grid-chart
          *ngIf="hiddenGridApi"
          [gridApi]="hiddenGridApi"
          [chartType]="reportVisualChartType"
          [chartModel]="lastKnownChartModel || savedChartModel"
          (chartModelChange)="onChartModelChange($event)">
        </app-ag-grid-chart>
      </div>
    </ng-template>
    }@else{
    <p>No data available</p>
    }
  </ng-template>
</div>
